import React, { createElement } from 'react'
import appFactory from './model/appModel'

/**
 * 加载单元模块
 * @param fullName 名称
 */
export const loadApp = (fullName) => {
  let appInfo = appFactory.getApp(fullName),
    Page, Model
  appInfo.load((_page, _model) => {
    Page = _page
    Model = new _model(appInfo)
  })

  return createElement(Page, {
    model: Model
  })
}

/**
 * 初始化单元Action
 */
const initAction = (appInfo) => {

}



// WEBPACK FOOTER //
// ./src/wbap-core-commit/appMiddleware.js